import Decimal from 'decimal.js';
import { useIntl } from 'react-intl';

import { Icon } from '../../components/icons/Icon';
import { Slider } from './Slider';
import styles from './InputRow.module.less';

interface Props {
  value: string;
  collateralBig: Decimal;
  minBtc: Decimal;
  maxBtc: Decimal;
  onValueChange: (raw: string) => void;
  onBlur: () => void;
  onSliderChange: (next: Decimal) => void;
}

export function CollateralRow({
  value,
  collateralBig,
  minBtc,
  maxBtc,
  onValueChange,
  onBlur,
  onSliderChange,
}: Props) {
  const intl = useIntl();
  // BTC midpoint: geometric mean — no per-currency override since BTC is universal.
  const mid = minBtc.mul(maxBtc).sqrt();

  return (
    <div className={styles.row}>
      <label className={styles.label}>
        {intl.formatMessage({ id: 'calculator.collateralBtc', defaultMessage: 'Collateral BTC' })}
      </label>
      <div className={styles.innerRow}>
        <div className={styles.inputWrap}>
          <input
            type="text"
            inputMode="decimal"
            className={styles.amountInput}
            value={value}
            onChange={e => onValueChange(e.target.value)}
            onBlur={onBlur}
            aria-label="Collateral BTC"
          />
          <span className={styles.suffix}>
            <Icon className={styles.suffixFlag} type="btc" aria-hidden />
            <span className={styles.suffixCode}>BTC</span>
          </span>
        </div>
        <Slider
          value={collateralBig}
          min={minBtc}
          mid={mid}
          max={maxBtc}
          ariaLabel="Collateral BTC slider"
          decimals={8}
          onValueChange={onSliderChange}
        />
      </div>
    </div>
  );
}
